<template>
  <div> 
           
    <v-container  grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <v-card>
                    <not-cpanel-tab 
                        :not_show="true"
                        :not="not" /> 
                    <v-toolbar color="primary" dark="" tile="" flat="" >
                        <v-toolbar-title>
                            MANAGE SISTERS
                        </v-toolbar-title>
                        <v-spacer></v-spacer> 
                        <v-btn @click="addSisters()" color="white" outlined="" rounded="" class="mr-2"><v-icon size="18" class="pr-1">mdi-plus-thick</v-icon> Add Sister</v-btn>
                        <v-menu  
                            bottom left 
                            v-model="menuSisters"
                            :close-on-content-click="false"
                            :nudge-width="250">
                            <template v-slot:activator="{ on }">
                            <v-btn class="mr-1"
                                dark outlined="" rounded=""
                                icon
                                v-on="on" >
                                <v-icon>mdi-tune</v-icon>
                            </v-btn>
                            </template>

                            <v-card>
                                <v-card-title primary-title>
                                    <v-layout >
                                        CUSTOMIZE TABLE
                                        <v-spacer></v-spacer>
                                        <v-btn icon="" @click="menuSisters=false"><v-icon>close</v-icon></v-btn>
                                    </v-layout>
                                </v-card-title>
                                <v-card-text>
                                    <v-list subheader="" dense="">
                                        <div v-for="(item, i) in xHeader_sisters" :key="i">
                                            <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                            <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_sisters,i)" >
                                                <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                                <v-list-item-title>{{item.name}}</v-list-item-title>
                                            </v-list-item> 
                                        </div> 
                                    </v-list> 
                                    <v-layout >
                                        <v-spacer></v-spacer>
                                        <v-btn @click="menuSisters = false" color="primary">OK</v-btn>
                                    </v-layout>
                                </v-card-text>
                                
                            </v-card> 
                        </v-menu>  
                    </v-toolbar>
                    <v-layout v-if="!page_show">
                        <not-page-spinner :not_show="true" /> 
                    </v-layout> 
                    <div v-else>
                    <v-card class="pa-2" tile=""> 
                        <!-- //Wards table -->
                        <div v-if="sisters" >
                            <v-card-title>
                                Congrgations 
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-card-title>
                            <!-- //CHECK CENTRES READ ACCESS -->

                            <div>
                                <v-data-table
                                    :headers="headers('sister')"
                                    :items="JOINED_sisters"
                                    :search="search" >

                                    <template v-slot:top>
                                        
                                    </template>
                                    <template v-slot:item.image="{ item }" > 
                                        <v-list-item-avatar  >
                                            <div v-if="item.image">
                                                <v-list-item-avatar size="80">
                                                    <v-img :src="item.image.link" />  
                                                </v-list-item-avatar>
                                            </div>
                                            <div v-else>
                                                <v-list-item-avatar size="80" color="b2">
                                            <!-- <v-img :src="'https://cdn.vuetifyjs.com/images/lists/1.jpg'" />   -->
                                                </v-list-item-avatar>
                                            </div>
                                        </v-list-item-avatar>
                                    </template>
                                    <template v-slot:item.action="{ item }" > 
                                        <v-layout >
                                            <v-hover v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="primary" class="pa-1">
                                                    <v-icon size="18" dark @click="editSister(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-pencil</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            <v-hover v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="red" class="pa-1" >
                                                    <v-icon size="18" dark @click="deleteSister(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-delete</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            <v-hover v-slot:default="{hover}" class="ma-1">
                                                <v-avatar  tile color="primary" class="pa-1">
                                                    <v-icon size="18" dark @click="viewSister(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-eye</v-icon>
                                                </v-avatar>
                                            </v-hover>  
                                        </v-layout>
                                        
                                    </template>
                                    <template v-slot:no-data>
                                        <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                            <v-icon>warning</v-icon>
                                            empty
                                        </v-layout>
                                    </template>
                                </v-data-table> 
                            </div> 
                        </div>
                    </v-card> 
                    </div>
                </v-card>
            </v-col>  
        </v-layout>
        <br>
    </v-container> 
    
    <!-- dialog new item -->
    <v-dialog v-model="dialog_add" persistent max-width="800px"> 
      <v-card color="">
        <v-card-title class="primary white--text" dark>
          <span class="headline">ADD NEW SISTER</span>
          <v-spacer></v-spacer>
                <v-btn v-if="!isAutoCode(inputCode)" @click="setAutoCode()" color="white" outlined="" rounded="" class="ml-2">AUTO GENERATE CODE</v-btn>
                <v-btn @click="onExcelSelect()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn>
                <v-btn class="ml-2" dark @click="dialog_add=false" icon=""><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg>
            <form id="itemDetailForm" @submit.prevent="submited()">
                <v-layout row wrap class="pa-1">   
                    <!-- Title -->
                    <v-flex xs12 md6>
                        <v-text-field required 
                        v-model="inputCode" 
                        type="number"
                        label="Code" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            required
                            v-model="input.staff" 
                            :items="['yes','no']"
                            
                            label="Staff"/> 
                    </v-flex>
                    <v-flex xs12   sm6> 
                        <v-text-field required  
                        v-model="input.first_name" 
                        label="First Name"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.surname" 
                        label="Surname" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.phone_number" 
                        label="Phone Number"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.email_address" 
                        label="Email Address"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.location_address" 
                        label="Location Address" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.post_address" 
                        label="Post Address" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.community" 
                        label="community"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.apostolate" 
                        label="Apostolate" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.position" 
                        label="Position" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            required
                            v-model="input.congregation_code" 
                            :items="not.selectorNames(congregations)"
                            
                            label="Congregation"/> 
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.date_of_birth" 
                        label="Date of Birth" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.date_of_first_vows" 
                        label="Date of first vows" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field  
                        v-model="input.level_of_education" 
                        label="Level of Education" > 
                        </v-text-field >
                    </v-flex>

                    
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input.desc" 
                            required  filled=""
                            label="Description" >
                            </v-textarea>
                    </v-flex>  
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text="" @click="dialog_add = false">CANCEL</v-btn>
                <v-btn color="primary" :loading="input.loading" dark="" type="submit">Submit</v-btn>
                </v-card-actions>
            </form> 
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        
      </v-card>
    </v-dialog>

    <!-- dialog edit -->
    <v-dialog v-model="dialog_edit" persistent max-width="800px"> 
      <v-card color="">
        <v-card-title class="primary white--text" dark>
            <span class="headline">EDIT SISTER</span>
            <v-spacer></v-spacer>
                 
            <v-btn class="ml-2" dark @click="dialog_edit=false" icon=""><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submitedEdit()">
                <v-layout row wrap class="pa-1">   
                    <!-- Title -->
                    <v-flex xs12 md6>
                        <v-text-field required 
                        v-model="inputCode" 
                        type="number"
                        label="Code" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            required
                            v-model="input.staff" 
                            :items="['yes','no']"
                            
                            label="Staff"/> 
                    </v-flex>
                    <v-flex xs12   sm6> 
                        <v-text-field required  
                        v-model="input.first_name" 
                        label="First Name"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.surname" 
                        label="Surname" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.phone_number" 
                        label="Phone Number"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.email_address" 
                        label="Email Address"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.location_address" 
                        label="Location Address" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.post_address" 
                        label="Post Address" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12  sm6 > 
                        <v-text-field required  
                        v-model="input.community" 
                        label="community"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.apostolate" 
                        label="Apostolate" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.position" 
                        label="Position" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            required
                            v-model="input.congregation_code" 
                            :items="not.selectorNames(congregations)"
                            
                            label="Congregation"/> 
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.date_of_birth" 
                        label="Date of Birth" > 
                        </v-text-field >
                    </v-flex> 
                    <v-flex xs12 sm6>
                        <v-text-field  
                        v-model="input.date_of_first_vows" 
                        label="Date of first vows" > 
                        </v-text-field >
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field  
                        v-model="input.level_of_education" 
                        label="Level of Education" > 
                        </v-text-field >
                    </v-flex>


                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input.desc" 
                            required  filled=""
                            label="Description" >
                            </v-textarea>
                    </v-flex>  
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text="" @click="dialog_edit = false">CANCEL</v-btn>
                <v-btn color="primary" :loading="input.loading" dark="" type="submit">Submit</v-btn>
                </v-card-actions>
            </form> 
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        
      </v-card>
    </v-dialog>

    <!-- select -->
    <div v-if="excelSelecter">
        <not-selecter-excel 
            :notShow="excelSelecter"
            @notNo="excelSelecter =!excelSelecter"
            @notYes="fileSelected"/>
    </div>

    <!-- Selected -->
    <v-dialog v-model="dialog_selected_sisters" persistent max-width="1000px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">UPLOAD SISTERS</span>
                <v-spacer></v-spacer>
                <v-btn v-if="!not.CODE_IS_AUTO(EXCEL_JS_sisters)" @click="EXCEL_JS_sisters=not.CODE_AUTO_GENERATE(EXCEL_JS_sisters)" rounded="" outlined="" dark>Auto Generate Code</v-btn>

                <v-btn  @click="dialog_selected_sisters=false" color="white" icon="" class="ml-2"><v-icon size="" class="pr-1">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <v-data-table
                        :headers="headers('excel')"
                        :items="JOINED_XL_sisters" >

                        <template v-slot:top>
                            
                        </template> 
                        <template v-slot:item.image="{ item }" > 
                            <v-list-item-avatar>
                                <div v-if="item.image_link">
                                    <v-list-item-avatar size="50">
                                        <v-img :src="item.image_link" />  
                                    </v-list-item-avatar>
                                </div>
                                <div v-else>
                                    <v-list-item-avatar size="50" color="b2"> 
                                    </v-list-item-avatar>
                                </div>
                            </v-list-item-avatar>
                        </template>

                        <template v-slot:item.action="{ item }" > 
                             
                            <v-hover v-slot:default="{hover}" class="ma-1">
                                <v-avatar tile color="red" class="pa-1" >
                                    <v-icon size="18" dark @click="deleteXlSisters(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                </v-avatar>
                            </v-hover> 
                        </template>
                        <template v-slot:no-data>
                            <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                <v-icon>warning</v-icon>
                                empty
                            </v-layout>
                        </template>
                    </v-data-table> 
                </v-container>
                <v-divider></v-divider>
                <br>
                <v-layout justify-center="">  
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog_selected_sisters=false" color="primary" text="">CANCEL</v-btn>
                    <v-btn :loading="input.loading" @click="uploadXlNew()" color="primary "><v-icon class="mr-2">mdi-cloud-upload</v-icon> UPLOAD SISTERS</v-btn>
                </v-layout>
            </v-card-text> 
      </v-card>
    </v-dialog>
  </div> 
</template>

<script>
    let pageName = "Sisters"
    let ACTION_TIME = 100
    export default {
        name:pageName,
        props:["not"],
        data() {
        return {
            page_current:1,
            page_size:10,

            dialog_add:false,
            dialog_edit:false,
            dialog_selected_sisters:false,
            menuSisters:false,
            page_show:false, 
            tab: null, 
            inputCode:null,
            input:{},
            images:[
                {src:require(`@/assets/awrim/group/g6.jpeg`),local:true},  
            ],
            excelSelecter:false,
            EXCEL_JS_sisters:[], 
            search: '',
            xHeader_sisters:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Image",show:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Name",show:true}, 
                {id:0,name:"First Name",show:false}, 
                {id:0,name:"Surname",show:false}, 
                {id:0,name:"Phone Number",show:true}, 
                {id:0,name:"Email Address",show:false}, 
                {id:0,name:"Location Address",show:false}, 
                {id:0,name:"Post Address",show:false}, 
                {id:0,name:"Community",show:false}, 
                {id:0,name:"Apostolate",show:false}, 
                {id:0,name:"Congregation",show:true}, 
                {id:0,name:"Position",show:false}, 
                {id:0,name:"Code",show:true},  
                {id:0,name:"Staff",show:false},  
                {id:0,name:"Date of Birth",show:false},  
                {id:0,name:"Date of First Vows",show:false},  
                {id:0,name:"Level Of Education",show:false},  
                {id:0,name:"Image Link",show:false},  
 
                // {id:0,name:"Added By",show:false}, 
                {id:0,name:"Added At",show:false}, 
                {id:0,name:"Updated At",show:false},
                {id:26,name:"ACTION",show:true},  
            ],
            xHeader_sisters2:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Image",show:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"First Name",show:true}, 
                {id:0,name:"Surname",show:true},
                {id:0,name:"Phone Number",show:true}, 
                {id:0,name:"Email Address",show:true}, 
                {id:0,name:"Location Address",show:true}, 
                {id:0,name:"Post Address",show:true},  
                {id:0,name:"Community",show:true}, 
                {id:0,name:"Apostolate",show:true}, 
                {id:0,name:"Congregation",show:true}, 
                {id:0,name:"Position",show:true}, 
                {id:0,name:"Code",show:true},  
                {id:0,name:"Staff",show:true},  
                {id:0,name:"Date of Birth",show:true},  
                {id:0,name:"Date of First Vows",show:true},  
                {id:0,name:"Level Of Education",show:true}, 
                // {id:26,name:"ACTION",show:true},  
            ],
        }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
            this.EventBus.$on('notNoDialog', this.notNoDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"350",
                notImages:this.images
            })
           this.pageLoad(2000)
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            congregations(){
                return this.$store.getters.getCongregation
            },
            sisters(){
                return this.$store.getters.getSisters
            },
            sistersSize(){
                let bs = this.sisters
                return bs?bs.length:0
            },
            p_sisters(){
                if (!this.sisters) {
                    return null
                }
                let list = [...this.sisters]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            JOINED_sisters(){
                let sisters = this.sisters 
                let joinSisters = this.not.JOIN_SISTERS(sisters)
                return joinSisters
            },
            JOINED_XL_sisters(){
                let sisters = this.EXCEL_JS_sisters
                return this.not.JOIN_SISTERS(sisters)  
            }
        },
        methods: {
            
            testDelete(){
                this.$store.dispatch("fi_deleteAllImages",{
                    path:"AWRIM/IMAGES/SETTINGS/Sisters", 
                    action:"Sister",
                    dispatch:"fi_deleteImage",
                    dispatchData:[

                    ]
                }) 
            },
            notYesDialog(action){
                if (action.code ===pageName+"=ADD-SISTER") {
                    if (this.input.check ) {
                        this.input.check = false 
                        this.$store.dispatch("fi_add",{
                            action:"Sister",
                            path:"AWRIM/SETTINGS/Sisters/",
                            data:action.data
                        }) 
                    } 
                }
                if (action.code ===pageName+'=EDIT-SISTER') {
                    if (this.input.check) {   
                        this.input.check = false 
                        setTimeout(() => {
                            this.input.loading = true 
                            this.$store.dispatch("fi_update",{
                                action:"Sister",
                                path:"AWRIM/SETTINGS/Sisters/"+action.data.key+"/",
                                data:action.data,
                                us:this.us
                            }) 
                        }, ACTION_TIME);  
                    } 
                } 
                else if (action.code===pageName+':'+2) {
                    this.input = {}
                    this.dialog = false
                }else if (action.code===pageName+':'+3) {
                    this.$store.dispatch("fi_add",{
                        action:"Sister",
                        path:"AWRIM/SETTINGS/Sisters/",
                        data:this.input
                    })
                }else if (action.code===pageName+"=DELETE-SISTER") { 
                    this.$store.dispatch("fi_delete",{
                        action:"Sister",
                        path:"AWRIM/SETTINGS/Sisters/"+action.key
                    })
                }else if (action.code===pageName+"=DELETE-IMAGE") { 
                    this.$store.dispatch("fi_deleteImage",{
                        path:"AWRIM/SETTINGS/Sisters/"+action.key,
                        link:action.image.link,
                        action:"Sister"
                    }) 
                }
                if (action.code ===pageName+'=AUTO-GENERATE-CODE') { 
                    this.EXCEL_JS_sisters= this.not.CODE_AUTO_GENERATE(this.EXCEL_JS_sisters) 
                    setTimeout(() => { 
                        this.not.notDialog(true,true,'GENERATED',"Codes, successfully generated.","OK")
                    }, ACTION_TIME);
                } 
                if (action.code ===pageName+'=AUTO-SET-CODE') { 
                    this.inputCode = (this.not.CODE_GET_LAST(action.data)+1)
                    setTimeout(() => { 
                        this.not.notDialog(true,true,'GENERATED',"Code, successfully generated.","OK") 
                    }, ACTION_TIME);
                }

                if (action.code ===pageName+'=SELECT-EXCEL') {
                    this.onExcelSelect()  
                } 
                if (action.code ===pageName+'=REMOVE-XL-CANDIDATE') {
                    let candidate =action.candidate 
                    let candidates = this.EXCEL_JS_sisters
                    this.EXCEL_JS_sisters = candidates.filter(ds=>{
                        return ds.code != candidate.code
                    }) 
                } 

                if (action.code ===pageName+'=XL-UPLOAD-NEW') {
                    if (this.input.check) {   
                        this.input.check = false 
                        setTimeout(() => {
                            this.input.loading = true 
                            this.$store.dispatch("fi_deleteAllImages",{
                                path:"AWRIM/IMAGES/SETTINGS/Sisters", 
                                action:"Sister",
                                dispatch:"fi_set",
                                dispatchData:{
                                    action:"Sisters",
                                    path:"AWRIM/SETTINGS/Sisters/",
                                    data:this.EXCEL_JS_sisters,
                                    us:this.us,
                                    array:true
                                }
                            })  
                        }, ACTION_TIME);  
                    }   
                }
                if (action.code ===pageName+'=ACCESS-DENIED') {
                    if (this.input.check) {   
                        this.input.check = false 
                        this.$router.push("/login")
                    }
                    
                } 
            }, 
            notNoDialog(action){
                if (action.code ===pageName+'=ACCESS-DENIED') {
                    if (this.input.check) {   
                        this.input.check = false 
                        this.$router.push("/")
                    }
                    
                } 
            },
            addSisters(){
                this.input = {},
                this.dialog_add = true
            },
            submited(){
                let total = this.not.TOTAL_C.SISTERS
                let size = this.sistersSize
                if (total<=size) {
                    this.not.notDialog(true,true,"Disk Full","You have reached total number of sisters that can be added on the system.","","OK")
                } else {
                    //convert code to int
                    let code = this.inputCode*1 
                    let array = this.sisters

                    //check code
                    if (code === 0) {
                        this.not.notDialog(true,true,"ERROR CODE",'Code can not be zero (0). Try another code or click AUTO GENERATE CODE BUTTON to generate a unic code.','CANCEL',"AUTO GENERATE CODE",{
                            code:pageName+"=AUTO-SET-CODE",
                            data:array
                        }) 
                        return
                    }
                    if (this.not.CODE_CHECK(array,code)) {
                        this.not.notDialog(true,true,"ERROR CODE",'This Code has already been used. Try another code or click AUTO GENERATE CODE BUTTON to generate a unic code.','CANCEL',"AUTO GENERATE CODE",{
                            code:pageName+"=AUTO-SET-CODE",
                            data:array
                        }) 
                        return
                    } 
                    this.input.check = true
                    this.input.code = code
                    this.input.congregation_code = this.not.selectorNamesCode(this.congregations,this.input.congregation_code) 
                    this.not.notDialog(true,true,"ADD","You are about to add new sister.","Cancel","Add",{
                        code:pageName+"=ADD-SISTER",
                        data:this.input
                    }) 
                }
            },
            editSister(sister){
                this.input = {},
                this.inputCode = sister.code
                this.input.key = sister.key
                this.input.staff = sister.staff
                this.input.first_name = sister.first_name
                this.input.surname = sister.surname
                this.input.community = sister.community
                this.input.phone_number = sister.phone_number
                this.input.email_address = sister.email_address
                this.input.location_address = sister.location_address
                this.input.post_address = sister.post_address
                this.input.apostolate = sister.apostolate
                this.input.position = sister.position
                this.input.desc = sister.desc
                this.input.link = sister.link?sister.link:null
                this.input.congregation_code = this.not.selectorCodeName(this.congregations,sister.congregation_code) 
                this.input.date_of_birth = sister.date_of_birth
                this.input.date_of_first_vows = sister.date_of_first_vows
                this.input.level_of_education = sister.level_of_education
                this.dialog_edit = true
            },
            submitedEdit(){ 
                this.input.check = true
                this.input.congregation_code = this.not.selectorNamesCode(this.congregations,this.input.congregation_code) 
                this.not.notDialog(true,true,"EDIT SISTER",'Are you sure you want to edit this candidate','CANCEL',"EDIT",{
                    code:pageName+"=EDIT-SISTER",
                    data:this.input
                })
                 
            },
            deleteSister(item){
                let image = item.image
                let key = item.key
                if (image) {
                    this.not.notDialog(true,true,"DELETE IMAGE FIRST","You must delete image before deleting this sister.","Cancel","Delete Image",{
                        code:pageName+"=DELETE-IMAGE",
                        key:key,image:image
                    }) 
                }else{
                    this.not.notDialog(true,true,"DELETE","You are about to delete this sister.","Cancel","Delete",{
                        code:pageName+"=DELETE-SISTER",
                        key:key
                    }) 
                }
            },
            viewSister(sister){
                this.not.go("/about/sisters/"+sister.key)
            },

            //Heades
            headers(type){
                let hds = null
                if (type === 'sister') {
                    hds = this.xHeader_sisters
                }else if (type === 'excel'){
                    hds = this.xHeader_sisters2
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },
            setAutoCode(){ 
                let code = this.not.CODE_GET_LAST(this.sisters) 
                this.inputCode= (code+1 )
                this.not.notDialog(true,true,'GENERATED',"Code, successfully generated.","OK") 
            },
            isAutoCode(number){ 
                let code = this.not.CODE_GET_LAST(this.candidates)
                if ((code+1 )=== number) {
                    return true
                }
                return false
            },

            //xl 
            deleteXlSisters(sister){
                this.not.notDialog(true,true,"REMOVE SISTER","Are you sure, you want to remove this sister from uploaded list","CANCEL","REMOVE",{
                    code:pageName+"=REMOVE-XL-SISTER",
                    sister:sister
                }) 
            },
            uploadXl(){
                this.not.notDialog(true,true,"UPLOAD TO LIST","Upload to already existing list","CANCEL","UPLOAD",{
                    code:pageName+"=XL-UPLOAD-OLD",
                    candidates:this.EXCEL_JS_sisters
                }) 
            },
            uploadXlNew(){
                let isOk = this.not.CODE_IS_OK(this.EXCEL_JS_sisters) 
                if (!isOk) { 
                    this.not.notDialog(true,true,"CODE ERROR","Please, make sure each sister has a valid uniq code. you can fix this by clicking AUTO GENERATE CODE button, to auto generate code.","CANCEL","AUTO GENERATE CODE",{
                        code:pageName+"=AUTO-GENERATE-CODE",
                        data:this.EXCEL_JS_sisters
                    }) 

                    return 
                } 
                this.input.check = true 
                this.not.notDialog(true,true,"UPLOAD NEW LIST","the current candidates list will be overlide with this new list","CANCEL","UPLOAD",{
                    code:pageName+"=XL-UPLOAD-NEW",
                    data:this.EXCEL_JS_sisters
                }) 
            },

            //-----------------[SELECT FILE]-----------
            onExcelSelect(){  
                this.input = {}
                this.inputCode = null
                this.dialog_add = false
                this.excelSelecter = !this.excelSelecter 
                 
            }, 
            fileSelected(wb){
                this.WB = wb
                this.excelSelecter = false
                this.EXCEL_JS_sisters=[] 

                let ws_sisters = wb.Sheets["sisters"]  
                if (!ws_sisters) {
                    this.not.notDialog(true,true,"ERROR","The select file does not contain sisters work sheet. Please, make sure you selected the right file and try again","CANCEL","TRY AGAIN",{
                        code:pageName+"=SELECT-EXCEL"
                    })
                } else {
                    let sisters = this.XLSX.utils.sheet_to_json(ws_sisters)  
                    let JOINED_sisters = []
                    let number = 0
                    sisters.forEach(cs => {
                        let dt = new Date
                        let date = dt.toISOString()
                        number = number+1 

                        JOINED_sisters.push({
                            code:cs.code,
                            staff:this.not.TEXT_UP(cs.staff)==="YES"?'yes':'no', 
                            first_name:cs.first_name?cs.first_name:'', 
                            surname:cs.surname?cs.surname:'',
                            phone_number:cs.phone_number?cs.phone_number:'',
                            email_address:cs.email_address?cs.email_address:'',
                            location_address:cs.location_address?cs.location_address:'',
                            post_address:cs.post_address?cs.post_address:'',
                            community:cs.community?cs.community:'',
                            apostolate:cs.apostolate?cs.apostolate:'',
                            congregation_code:cs.congregation_code?cs.congregation_code:'',
                            position:cs.position?cs.position:'',
                            date_of_birth:cs.date_of_birth?cs.date_of_birth:'', 
                            date_of_first_vows:cs.date_of_first_vows?cs.date_of_first_vows:'', 
                            level_of_education:cs.level_of_education?cs.level_of_education:'', 
                            desc:cs.desc?cs.desc:'',
                            date:date,
                            uid:this.us.uid
                        })
                    });
                    this.EXCEL_JS_sisters = JOINED_sisters
                    this.dialog_selected_sisters = true  
                }
            },

            //LOAD
            ACCESS_PAGE(){
                if (!this.us) {
                    this.input.check = true
                    this.not.notDialog(true,true,"ACCESS DENIED","To access this page. You mast loggng first. Click Logging button to continue log in or Cancel to go back home","CANCEL","LOGGIN",{
                        code:pageName+"=ACCESS-DENIED"
                    })
                }
            },
           //LOAD
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/Sisters'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/Sister'
                        })
                        let updating = ps.find(process=>{
                            return process.name == 'updating/Sister'
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/Sister'
                        })
                        let deletingImage = ps.find(process=>{
                            return process.name == 'deleting/image/Sisters'
                        })
                        let setting = ps.find(process=>{
                            return process.name == 'setting/Sisters'
                        }) 

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.ACCESS_PAGE()
                        }

                        if (getting) {
                            this.page_show =false
                        }else{
                            this.page_show =true
                        }

                        if (adding) {
                            this.not.notDialogP(true,false,'adding...')
                            this.input.loading = true
                        }else{ 
                        }  

                        if (adding) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        } 

                        if (updating) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        } 
    
                        if (deleting) {
                            this.not.notDialogP(true,true,'deleting...') 
                        }else{ 
                        }  

                        if (deletingImage) {
                            this.not.notDialogP(true,true,'deleting image...') 
                        }else{ 
                        }  

                        if (setting) {
                            this.not.notDialogP(true,false,'Uploading...')
                            this.input.loading = true
                        }else{ 
                        } 

                    }else{
                        this.page_show =true
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                    //check response
                    if (res.res==='adding/Sister/successful') { 
                        this.not.notDialog(true,true,'Successful','Sister, successfuly added.','','OK',{code:pageName+':'+2})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_add = false
                    }else if (res.res==='adding/Sister/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding Sister.','Cancel','Try again',{code:pageName+':'+3})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/Sister/successful') { 
                        this.not.notDialog(true,true,'Successful','Sister, successfuly deleted.','','OK')
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                        
                    }else if (res.res==='deleting/Sister/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting Sister.','OK')
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/image/Sister/successful') { 
                        this.not.notDialog(true,true,'Successful','Image, successfuly deleted.','','OK')
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/image/Sister/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting Sister.','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }


                    if (res.res==='updating/Sister/successful') { 
                        this.not.notDialog(true,true,'Successful','Sister successfully edited.','','OK',{code:pageName+'=EDIT-SISTER-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_edit = false
                    }else if (res.res==='updating/Sister/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the Sister. make sure your password is correct or contact admin','','OK',{code:pageName+'=EDIT-SISTER-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    if (res.res==='setting/Sisters/successful') { 
                        this.not.notDialog(true,true,'Successful','Sister successfully upload.','','OK',{code:pageName+'=SETTING-SISTER-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_selected_sisters = false
                    }else if (res.res==='setting/Sisters/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while uploading the candidates. ','','OK',{code:pageName+'=SETTING-SISTER-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                        this.dialog_selected_sisters = false
                    } 
                },t)
            }
        },
        watch: {
            us(v){
                this.pageLoad(1)
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
